  <!-- Title -->
<h2 *ngIf="!IsCompletionView" class="sectionTitle">{{ 'FRONT_USER.ADDITIONAL_WORK_FORM.ADDITIONAL_WORL' | translate }}</h2>
<div  *ngIf="showRequest"  >
  <!--load shipyard request read only-->
  <div *ngIf="baseRequestDTO&&!IsCompletionView" >

    <div *ngIf="baseRequestDTO.ServiceId==serviceType.Repair">
      <app-create-repair-request></app-create-repair-request>
    </div>
    <div *ngIf="baseRequestDTO.ServiceId==serviceType.NonDestructiveTestingWork">
      <app-non-destructive-testing-work></app-non-destructive-testing-work>
    </div>
    <div *ngIf="baseRequestDTO.ServiceId==serviceType.HardnessTest">
      <app-create-hardness-test-request></app-create-hardness-test-request>
    </div>
    <div *ngIf="baseRequestDTO.ServiceId==serviceType.DynamicBalancing">
      <app-dynamic-balancing-request></app-dynamic-balancing-request>
    </div>
    <div *ngIf="baseRequestDTO.ServiceId==serviceType.FloatingCranes">
      <app-create-floating-cranes-request></app-create-floating-cranes-request>
    </div>
    <div *ngIf="baseRequestDTO.ServiceId==serviceType.FiberGlass">
      <app-fibberglass-request></app-fibberglass-request>
    </div>
    <div *ngIf="baseRequestDTO.ServiceId==serviceType.Salvage">
      <app-salvage-request></app-salvage-request>
    </div>
  </div>


    <div class="form-container" >
      <h4  class="section-title">{{ 'FRONT_USER.ADDITIONAL_WORK_FORM.ADDITIONAL_WORL' | translate }}</h4>
      <!-- load shipyard request Department name read only -->
      <div class="form-group" *ngIf="baseRequestDTO">
        <label for="ServiceCost">{{ 'FRONT_USER.ADMIN_DECISION_FORM.DEPARTMENT' | translate}}</label>
        <div *ngIf="displayedLang=='NameEN'">
          <input type="text" class="form-control" id="ServiceId" name="ServiceId"
            [(ngModel)]="baseRequestDTO.Service.NameEN" [disabled]="true" />
        </div>
        <div *ngIf="displayedLang=='NameAR'">
          <input type="text" class="form-control" id="ServiceId" name="ServiceId"
            [(ngModel)]="baseRequestDTO.Service.NameAR" [disabled]="true" />
        </div>
      </div>
    </div>
    <div class="form-container">
      <div class="form-group" *ngIf="!isReadOnly">

        <div class="form-custom-inputs">
          <div *ngFor="let decisions of additionalDecisionsKeys;let i='index'" class="custom-Radio">
            <input type="radio" [id]=[decisions] (change)="changeDecision(additionalDecisions[decisions])"
               name="Decision"  [value]="additionalDecisions[decisions]" />

            <label [for]="[decisions]">{{ 'FRONT_USER.ADDITIONAL_WORK_FORM.' + decisions | translate }}</label>
          </div>
        </div>
        <!-- If admin choose add additional work -->
        <!-- <input type="button" (click)="addAdditionalWork()" class="btn btn-primary SCAcustomBtn"
        value="{{ 'FRONT_USER.ADDITIONAL_WORK_FORM.ADD_ADDITIONAL_WORK' | translate}}"> -->

        <!-- if admin choose add  work copeletion -->
        <!-- <input type="button" (click)="adminResponse(0)" class="btn btn-primary SCAcustomBtn"
        value="{{ 'FRONT_USER.ADDITIONAL_WORK_FORM.WORK_COMPELETION' | translate}}">
    </div> -->

      </div>
    </div>

    <!--Additional Work Form-->
    <div [hidden]="testedDiv != additionalDecisions.additional && !isReadOnly">
      <form [formGroup]="additionalWorkForm"  >

      <fieldset [disabled]="isReadOnly"  >
        <div class="form-container">

          <!-- EstimatedCostOfAdditionalWork -->
          <div class="form-group">
            <label
              for="EstimatedCostOfAdditionalWork">{{ 'FRONT_USER.ADDITIONAL_WORK_FORM.ESTIMATED_COST_OF_ADDITIONAL_WORK' | translate}}</label>
            <span class="red"> *</span>
            <div class="input-group">
              <input type="text"  appOnlyDecimal  [onlydecimal]="true" class="form-control" id="EstimatedCostOfAdditionalWork"
                name="EstimatedCostOfAdditionalWork" formControlName="EstimatedCostOfAdditionalWork" />
                <span class="input-group-addon">$</span>
            </div>
            <div *ngIf="submitted ||( f.EstimatedCostOfAdditionalWork?.errors&&f.EstimatedCostOfAdditionalWork?.dirty )"
              class="red ">
              <div *ngIf="f.EstimatedCostOfAdditionalWork?.errors?.required">
                {{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
              <div *ngIf="f.EstimatedCostOfAdditionalWork?.errors?.pattern">
                {{'FRONT_USER.NUMBER_ERROR' | translate}}</div>
            </div>
          </div>

          <!-- AdditionalWork -->
          <div class="form-group">
            <label for="AdditionalWork">{{ 'FRONT_USER.ADDITIONAL_WORK_FORM.ADDITIONAL_WORK' | translate}}</label>
            <span class="red"> *</span>
            <textarea class="form-control" id="AdditionalWork" name="AdditionalWork" formControlName="AdditionalWork"
              style="height: 186px;  width: 400px;"></textarea>
            <div *ngIf="submitted && f.AdditionalWork?.errors" class="red ">
              <div *ngIf="f.AdditionalWork?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}
              </div>
              <div *ngIf="f.AdditionalWork?.errors?.maxlength">{{'FRONT_USER.MAX_LENGTH_ERROR' | translate}}</div>
            </div>
          </div>
        </div>
      </fieldset>
      <!-- Submit Button -->
      <div class="form-group" *ngIf="!isReadOnly">
        <button Confirmation (confirmationClick)="onSubmit()" class="btn SCAcustomBtn">{{ 'FRONT_USER.SAVE' | translate}}</button>
      </div>

      <!-- User Decision Of Additional Work That Added by Admin  -->
      <div *ngIf="isReadOnly&&!IsCompletionView&&!isRequestHistory">
        <div class="form-group">
          <label >
            {{ 'FRONT_USER.ADMIN_DECISION_FORM.DECISION' | translate }}</label>
          <span class="red">
            *</span>
          <div class="form-custom-inputs">
            <div *ngFor="let decisions of decisionKeys;let i='index'" class="custom-Radio">
              <input type="radio" [id]=[decisions] (change)="changeUserDecision(decision[decisions])"
                 [value]="decision[decisions]" name="Decision" />

              <label [for]="[decisions]">{{ 'FRONT_USER.ADMIN_DECISION_FORM.' + decisions | translate }}</label>


            </div>
          </div>


        </div>

        <button *ngIf="!IsCompletionView" type="button" class="btn btn-primary SCAcustomBtn" Confirmation (confirmationClick)="userResponse(userDecision)">
          {{ 'FRONT_USER.SAVE' | translate}}
        </button>
        <!-- <button type="button" class="btn btn-primary SCAcustomBtn" style="background-color:#28a745!important"
            (click)="userResponse(ternartDecision.Accept)"> {{ 'FRONT_USER.ACCEPT' | translate}}</button>
          <button type="button" class="btn btn-primary SCAcustomBtn" style="background-color:#dc3545 !important"
            (click)="userResponse(ternartDecision.Reject)"> {{ 'FRONT_USER.REJECT' | translate}}</button> -->
      </div>

    </form>
  </div>
    <!-- User Decision Of Additional Work That Added by Admin  -->
 <div *ngIf="isReadOnly&&isRequestHistory"  >
          <fieldset class="form-container" [disabled]="true">
            <div class="form-group">
              <h4  class="section-title">
              {{ 'FRONT_USER.DECISION' | translate }}</h4>
              <div class="form-custom-inputs">
          <div class="custom-Radio">
              <div  class="custom-Radio">
                <input type="radio"  [checked]="!additonalWorkIsRejectedByUser"  />

                <label >{{'FRONT_USER.ADMIN_DECISION_FORM.Accept'| translate }}</label>
              </div>
            </div>
            <div class="custom-Radio">
              <div  class="custom-Radio">
                <input type="radio"  [checked]="additonalWorkIsRejectedByUser"  />

                <label >{{'FRONT_USER.ADMIN_DECISION_FORM.Reject'| translate }}</label>
              </div>
            </div>

          </div>

            </div>
          </fieldset>

        </div>
  <div class="form-group" *ngIf="!isReadOnly&&testedDiv==additionalDecisions.compeletion">
    <button type="button" class="btn SCAcustomBtn"
    Confirmation (confirmationClick)="adminResponse(0)" >{{ 'FRONT_USER.SAVE' | translate}}</button>

  </div>
</div>


<!-- Confirmation -->
<div *ngIf="!showRequest&&!isErrorMessage&&!lockTaskErrorMessage" class="alert alert-success" role="alert">
  <div class="alignC">
    <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 300 300" xml:space="preserve"
      xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g>
        <g>
          <path
            d="M150,0C67.157,0,0,67.157,0,150s67.157,150,150,150s150-67.157,150-150S232.843,0,150,0z M223.413,128.844l-76.696,69.434    c-1.88,1.704-4.072,2.85-6.367,3.452c-1.979,0.882-4.103,1.338-6.235,1.338c-3.794,0-7.594-1.398-10.566-4.217l-47.222-44.826    c-6.147-5.836-6.398-15.549-0.563-21.696c5.83-6.147,15.546-6.401,21.696-0.565l37.587,35.678l67.764-61.355    c6.282-5.688,15.987-5.208,21.675,1.076C230.174,113.448,229.694,123.153,223.413,128.844z">
          </path>
        </g>
      </g>
    </svg>
    <p>{{ 'FRONT_USER.ADDITIONAL_WORK_FORM.ADMIN_SUCCESS_MESSAGE' | translate }}</p>
    <p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/workspace">{{ 'FRONT_USER.WORKSPACE.MY_WORKSPACE' | translate }}</a></p>
  </div>
</div>

<!-- error message -->
<div *ngIf="!showRequest&&isErrorMessage" class="alert alert-danger" role="alert">
    <div class="alignC">
        <i class="icon-error"></i>
        <p>{{'FRONT_USER.ERRORS_MESSAGES.ERROR' | translate}}</p>
        <p>{{'FRONT_USER.ERRORS_MESSAGES.EROOR_MESSAGE' | translate}}</p>

    </div>
</div>


<div *ngIf="!showRequest&&lockTaskErrorMessage" class="alert alert-warning" role="alert">
  <div class="alignC">
      <i class="icon-error"></i>
      <p>{{'FRONT_USER.ERRORS_MESSAGES.ERROR' | translate}}</p>
      <p>{{'FRONT_USER.ERRORS_MESSAGES.LOCK_TASK_ERROR_MESSAGE' | translate}}</p>

  </div>
</div>
